import { getRowKeyIter } from '../config/utils'
export default {
  data () {
    return {
      states: {
        radioSelected: ''
      }
    }
  },
  methods: {
    setRadioSelectedInRows (uniqueId, rowData, isPublished = true) {
      this.states.radioSelected = uniqueId
      isPublished && this.table.$emit('table2-radio-change', uniqueId, rowData)
      isPublished && this.table.$emit('radio-change', uniqueId, rowData)
    },
    getRadioSelected () {
      return this.states.radioSelected
    },
    getRadioSelectionRows() {
      const id = this.getRadioSelected()
      if (!id) return {}
      const { rowKey } = this.table.$props
      return (this.states.renderData || []).find(rowData => getRowKeyIter(rowData, rowKey) === id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/radio.js